import './Message.css'

import succeed from '../../Media/Message.Media/succeed.png'
import failed from '../../Media/Message.Media/failed.png'
import warning from '../../Media/Message.Media/warning.png'

const Message = ({ message, state, visible, onClose, onMouseEnter, onMouseLeave }) => {
    return (
        <div 
            className={`message-container ${visible ? 'show' : 'hide'}`} 
            onMouseEnter={onMouseEnter} 
            onMouseLeave={onMouseLeave}
        >
            <img
                className='message-image'
                src={state === 'succeed' ? succeed : state === 'failed' ? failed : warning}
                alt='status'
            />
            <span className='message-content'>{message}</span>
            <button className='message-button' onClick={onClose}>Close</button>
        </div>
    );
};

export default Message
